import React, { useState, useEffect } from "react";
import { useForm, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import ModalBody from "@material-tailwind/react/ModalBody";
import ModalFooter from "@material-tailwind/react/ModalFooter";
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import Button from "@material-tailwind/react/Button";
import Input from "@material-tailwind/react/Input";
import InputIcon from "@material-tailwind/react/InputIcon";
import { useRegister } from "query/actions/Registration";
import { Spinner } from 'components/Spinner';
import ResponseStatus from "./ResponseStatus";
import { toast } from 'react-toastify';

export default function Register({closeModal}){    
    const [page, setPage] = useState(null);
    const [showPassword, setShowPassword] = useState(false);
    const { mutate, error, isError, isLoading, isSuccess } = useRegister();

    const phoneRegExp = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/
    const validationSchema = Yup.object().shape({
        mykad: Yup.string().required(`Ruangan Wajib Diisi`)
                .matches(phoneRegExp, 'No. MyKad Tidak Sah')
                .min(12, "Minimum nombor adalah 12 digit")
                .max(12, "Maksimum nombor adalah 12 digit"),
        name: Yup.string().required(`Ruangan Wajib Diisi`),
        phone: Yup.string().required(`Ruangan Wajib Diisi`)
                .matches(phoneRegExp, 'No. Telefon Tidak Sah')
                .min(10, "Minimum nombor adalah 10 digit")
                .max(12, "Maksimum nombor adalah 12 digit"),
        email: Yup.string().email('Format emel salah').required(`Ruangan Wajib Diisi`),
        password: Yup.string().required(`Ruangan Wajib Diisi`),
        confirm_password: Yup.string().oneOf([Yup.ref('password'), null], 'Katalaluan Tidak Sama')
    });
    const { register, handleSubmit, control, formState:{ errors }, reset } = useForm({
        defaultValues: {
            mykad: '',
            name: '',
            phone: '',
            email: '',
            password: '',
            confirm_password: ''
        },
        resolver: yupResolver(validationSchema),
    });
    const onSubmit = async (data) => {
        // console.log('errorserrors',errors)
        console.log('datadata',data)
        // // logIn(data)
        const loadingToast = toast.loading("Please wait...", {
            position: toast.POSITION.TOP_CENTER
        });
        await mutate(data, {
            onSuccess: (data) => {
                Notify(data.data.response.response_code, loadingToast)
            }
        })
    }

    const Notify = (code, loadingToast) => {
        if(code == '200'){
            toast.update(loadingToast, { 
                render: "Daftar Baru Berjaya!", 
                type: "success", 
                isLoading: false,
                position: toast.POSITION.TOP_CENTER,
                autoClose: 5000
            });
        }

        if(code == '201'){
            toast.update(loadingToast, { 
                render: "Akaun telah wujud!", 
                type: "error", 
                isLoading: false,
                position: toast.POSITION.TOP_CENTER,
                autoClose: 5000
            });
        }
        
        if(code == '500'){
            toast.update(loadingToast, { 
                render: "Ralat!", 
                type: "error", 
                isLoading: false,
                position: toast.POSITION.TOP_CENTER,
                autoClose: 5000
            });
        }
        
        setPage(
            <ResponseStatus 
                type={code == '200' ? 'success' : 'error'} 
                close={null} 
                title={code == '200' ? 'Berjaya!' : 'Gagal!'} 
                subtitle={code == '200' ? 'Log masuk ke akaun anda sekarang.' : 
                    code == '201' ? 'Akaun telah wujud. Sila log masuk atau klik lupa katalaluan untuk menerima katalaluan sementara.' : 
                    'Daftar baru gagal, sila cuba lagi.'}
                isButton={null}
            />
        )
    }

    const passwordVisibility = () => {
        setShowPassword(!showPassword)
    }

    return (
        <>
        {/* <div className="lg:w-2xl md:w-lg"> */}
            {isLoading ? <div className='flex justify-center items-center'><Spinner /></div> :
            page != null ? page :
            <> 
            <DialogContent>
                <div className="flex flex-wrap w-full">
                    <span className="block text-sm mb-5">Sila lengkapkan semua ruangan.</span>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <div className="flex flex-wrap my-1">
                            <div className="w-full lg:w-6/12 lg:pr-2 mb-6 font-light">
                                <Controller
                                    render={({ field }) => (
                                        <Input
                                            {...field}
                                            type="text"
                                            color="lightBlue"
                                            size="regular"
                                            outline={true}
                                            placeholder="No. MyKad (ID Pengguna)"
                                            error={errors.mykad ? errors.mykad.message : ''}
                                        />
                                    )}
                                    control={control}
                                    name="mykad"
                                />
                            </div>
                            
                            <div className="w-full lg:w-6/12 lg:pl-2 mb-6 font-light">
                                <Controller
                                    render={({ field }) => (
                                        <Input
                                            {...field}
                                            type="text"
                                            color="lightBlue"
                                            size="regular"
                                            outline={true}
                                            placeholder="Nama Penuh"
                                            error={errors.name ? errors.name.message : ''}
                                        />
                                    )}
                                    control={control}
                                    name="name"
                                />
                            </div>

                            <div className="w-full lg:w-6/12 lg:pr-2 mb-6 font-light">
                                <Controller
                                    render={({ field }) => (
                                        <Input
                                            {...field}
                                            type="text"
                                            color="lightBlue"
                                            size="regular"
                                            outline={true}
                                            placeholder="No. Telefon"
                                            error={errors.phone ? errors.phone.message : ''}
                                        />
                                    )}
                                    control={control}
                                    name="phone"
                                />
                            </div>
                            
                            <div className="w-full lg:w-6/12 lg:pl-2 mb-6 font-light">
                                <Controller
                                    render={({ field }) => (
                                        <Input
                                            {...field}
                                            type="email"
                                            color="lightBlue"
                                            size="regular"
                                            outline={true}
                                            placeholder="Emel"
                                            error={errors.email ? errors.email.message : ''}
                                        />
                                    )}
                                    control={control}
                                    name="email"
                                />
                            </div>

                            <div className="w-full lg:w-6/12 lg:pr-2 mb-6 font-light">
                                <Controller
                                    render={({ field }) => (
                                        <InputIcon
                                            {...field}
                                            type="password"
                                            color="lightBlue"
                                            size="regular"
                                            outline={true}
                                            placeholder="Katalaluan"
                                            // iconFamily="font-awesome"
                                            // iconName="fas fa-eye"
                                            error={errors.password ? errors.password.message : ''}
                                        />
                                    )}
                                    control={control}
                                    name="password"
                                />
                            </div>
                            
                            <div className="w-full lg:w-6/12 lg:pl-2 mb-6 font-light">
                                <Controller
                                    render={({ field }) => (
                                        <Input
                                            {...field}
                                            type="password"
                                            color="lightBlue"
                                            size="regular"
                                            outline={true}
                                            placeholder="Ulang Katalaluan"
                                            error={errors.confirm_password ? errors.confirm_password.message : ''}
                                        />
                                    )}
                                    control={control}
                                    name="confirm_password"
                                />
                            </div>
                        </div>
                    </form>
                </div>
            </DialogContent>
            <DialogActions>
                <Button 
                    color="gray"
                    buttonType="link"
                    onClick={(e) => closeModal()}
                    ripple="dark"
                >
                    Kembali
                </Button>

                <Button
                    color="cyan"
                    onClick={handleSubmit(onSubmit)}
                    ripple="light"
                >
                    Daftar
                </Button>
            </DialogActions>
            </>
            }
        {/* </div> */}
        </>
        
    )
}